import { SetStateAction, Dispatch, createContext } from 'react';

export const canCloseCurrentModalContext = createContext<[boolean, Dispatch<SetStateAction<boolean>>]>([true, () => { throw new Error('you\'re not in a modal context'); }]);
